import React, { useCallback, useContext, useEffect, useState } from 'react';
import MapContext from '../MapContext.js';
import Feature from "../feature/Feature.js";
export default function Layer({
  type,
  children,
  style,
  onInsertAt,
  onRemoveAt,
  onSetAt,
  drawingMode
}) {
  const {
    map,
    onClick,
    onMouseOver,
    onMouseOut,
    onContextMenu
  } = useContext(MapContext);
  const [instance, setInstance] = useState();
  const [clickListener, setClickListener] = useState();
  const [mouseOverListener, setMouseOverListener] = useState();
  const [mouseOutListener, setMouseOutListener] = useState();
  const [contextMenuListener, setContextMenuListener] = useState();
  const [insertAtListener, setInsertAtListener] = useState();
  const [removeAtListener, setRemoveAtListener] = useState();
  const [setAtListener, setSetAtListener] = useState();
  useEffect(() => {
    const inst = new window.google.maps.Data({
      map
    });
    setInstance(inst);
    if (style) {
      inst.setStyle(style);
    }
    return () => {
      inst.setMap(null);
    };
  }, []);
  useEffect(() => {
    if (instance) {
      if (drawingMode !== undefined) {
        instance.setDrawingMode(drawingMode);
      }
    }
  }, [instance, drawingMode]);
  useEffect(() => {
    if (insertAtListener) {
      window.google.maps.event.removeListener(insertAtListener);
    }
    if (onInsertAt && instance) {
      setInsertAtListener(instance.addListener('addfeature', onInsertAt));
    }
  }, [instance, onInsertAt]);
  useEffect(() => {
    if (removeAtListener) {
      window.google.maps.event.removeListener(removeAtListener);
    }
    if (onRemoveAt && instance) {
      setRemoveAtListener(instance.addListener('removefeature', onRemoveAt));
    }
  }, [instance, onRemoveAt]);
  useEffect(() => {
    if (setAtListener) {
      window.google.maps.event.removeListener(setAtListener);
    }
    if (onSetAt && instance) {
      setSetAtListener(instance.addListener('setgeometry', onSetAt));
    }
  }, [instance, onSetAt]);
  useEffect(() => {
    if (instance && onClick) {
      if (clickListener) {
        window.google.maps.event.removeListener(clickListener);
      }
      setClickListener(instance.addListener('click', onClick));
    }
  }, [onClick, instance]);
  useEffect(() => {
    if (instance && onMouseOver) {
      if (mouseOverListener) {
        window.google.maps.event.removeListener(mouseOverListener);
      }
      setMouseOverListener(instance.addListener('mouseover', onMouseOver));
    }
  }, [onMouseOver, instance]);
  useEffect(() => {
    if (instance && onMouseOut) {
      if (mouseOutListener) {
        window.google.maps.event.removeListener(mouseOutListener);
      }
      setMouseOutListener(instance.addListener('mouseout', onMouseOut));
    }
  }, [onMouseOut, instance]);
  useEffect(() => {
    if (instance && onContextMenu) {
      if (contextMenuListener) {
        window.google.maps.event.removeListener(contextMenuListener);
      }
      setContextMenuListener(instance.addListener('contextmenu', onContextMenu));
    }
  }, [onContextMenu, instance]);
  const createGeometry = useCallback(coordinates => {
    switch (type) {
      case 'symbol':
      case 'circle':
        return {
          type: 'Point',
          coordinates
        };
      case 'fill':
        if (Array.isArray(coordinates[0][0][0])) {
          return {
            type: 'MultiPolygon',
            coordinates
          };
        }
        return {
          type: 'Polygon',
          coordinates
        };
      case 'line':
        return {
          type: 'LineString',
          coordinates
        };
      default:
        return {
          type: 'Point',
          coordinates
        };
    }
  }, [type]);
  if (!instance) {
    return null;
  }
  return React.Children.map(children, child => {
    const {
      coordinates
    } = child.props;
    if (child.type !== Feature) {
      return child;
    }
    return /*#__PURE__*/React.cloneElement(child, {
      data: instance,
      ...createGeometry(coordinates)
    });
  });
}